import { memo } from 'react';

import { BzTabsContainer, BzTabsContent } from '../../components';
import Alert from '../Alerts/Alert';
import AlertLog from '../Alerts/AlertLog';
import { useLocation } from 'react-router';
import { LOCATIONS } from '../../utils/global_variables';


const Alerts = ({ isVertical, selectAllCheckbox, selectedCategory, selectedAlerts, setSelectedAlerts, setSelectedCategory, AlertPortfolio, arrAlertAttributes, arrAlertLogAttributes, activeTab, setActiveTab, handleALertDelet, bShowDeleteCheckbox, showDeleteCheckbox, handleCloseDeleteAlert, handleSelectAlertForDelete, arrSelectedDeleteAlert, handleDeleteSingleAlert, ...props }) => {
    const location = useLocation();

    return (
        <>
            {
                location.pathname === LOCATIONS.WATCHLIST ?
                    <div className='' {...props}>
                        <BzTabsContainer>
                            <BzTabsContent isActive={activeTab === 'alerts'} showDefault={activeTab === 'alerts'} tabKey='alerts'>
                                {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- Start */}
                                <Alert isVertical={isVertical} selectAllCheckbox={selectAllCheckbox} selectedCategory={selectedCategory} selectedAlerts={selectedAlerts} setSelectedAlerts={setSelectedAlerts} setSelectedCategory={setSelectedCategory} bShowDeleteCheckbox={bShowDeleteCheckbox} handleALertDelet={handleALertDelet} handleCloseDeleteAlert={handleCloseDeleteAlert} handleSelectAlertForDelete={handleSelectAlertForDelete} handleDeleteSingleAlert={handleDeleteSingleAlert} arrSelectedDeleteAlert={arrSelectedDeleteAlert} />
                                {/* Vinit R - 23-04-2024 BT-107432 Breeze - Alerts -- End */}
                            </BzTabsContent>
                            <BzTabsContent isActive={activeTab === 'alertlog'} showDefault={activeTab === 'alertlog'} tabKey='alertlog'>
                                <AlertLog isVertical={isVertical} arrAlertAttributes={arrAlertAttributes} bShowDeleteCheckbox={bShowDeleteCheckbox} handleSelectAlertForDelete={handleSelectAlertForDelete} handleDeleteSingleAlert={handleDeleteSingleAlert} arrSelectedDeleteAlert={arrSelectedDeleteAlert} />
                            </BzTabsContent>
                        </BzTabsContainer>
                    </div>
                    :
                    (
                        location.pathname === LOCATIONS.PORTFOLIO ?
                            <>
                                {/* Vaibhav Singh : BT-117135- 20-09-2023: unimplemented code removed  */}
                                <div className='portfolio-alertstabs-scroll' {...props}>   {/* Hari P: 12-11-2023 SAT-BT-107432 2nd Cycle  UI issue fixed */}
                                    <BzTabsContainer>
                                        <BzTabsContent className='px-1' isActive={activeTab === 'alerts'} showDefault={activeTab === 'alerts'} tabKey='alerts'>
                                            <Alert selectAllCheckbox={selectAllCheckbox} AlertPortfolio={AlertPortfolio} arrAlertAttributes={arrAlertAttributes} bShowDeleteCheckbox={bShowDeleteCheckbox} handleSelectAlertForDelete={handleSelectAlertForDelete} handleALertDelet={handleALertDelet} handleDeleteSingleAlert={handleDeleteSingleAlert} arrSelectedDeleteAlert={arrSelectedDeleteAlert} />
                                        </BzTabsContent>
                                        <BzTabsContent className='px-1' isActive={activeTab === 'alertlog'} showDefault={activeTab === 'alertlog'} tabKey='alertlog'>
                                            {/* ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - Start */}
                                            <AlertLog selectAllCheckbox={selectAllCheckbox}
                                                arrAlertAttributes={arrAlertAttributes}
                                                AlertPortfolio={AlertPortfolio} arrAlertLogAttributes={arrAlertLogAttributes}
                                                bShowDeleteCheckbox={bShowDeleteCheckbox} handleSelectAlertForDelete={handleSelectAlertForDelete}
                                                handleALertDelet={handleALertDelet} handleDeleteSingleAlert={handleDeleteSingleAlert} arrSelectedDeleteAlert={arrSelectedDeleteAlert} />
                                            {/* ManasaB : 14/12/2023 : BT-123413 : ALerts Bug Fixing - 3 - End */}
                                        </BzTabsContent>
                                    </BzTabsContainer>
                                </div>
                            </> : null

                    )
            }

        </>
    );



};

export default memo(Alerts);